const baseUrl = process.env.API_BASE_URL;

export const endpoints = {
	USER: {
		LOGIN: () => `${baseUrl}/api/sessions`,
		FORGET_PASSWORD: () => `${baseUrl}/api/passwords/forget`,
		RESET_PASSWORD: () => `${baseUrl}/api/passwords/reset`,
		REGISTER: () => `${baseUrl}/api/v1/user_panel/auth/register`,
		CREATE_OTP: () => `${baseUrl}/api/v1/user_panel/auth/otp_create`,
		PROFILE: () => `${baseUrl}/api/v1/user_panel/user/show`,
		GET_PROFILE: (id) => `${baseUrl}/api/v1/user_panel/user/${id}`,
		UPDATE_PROFILE: (id) => `${baseUrl}/api/v1/user_panel/user/${id}`,
		UPDATE_PROFILE_OTP: () => `${baseUrl}/api/v1/user_panel/otp`,
		UPDATE_PROFILE_OTP_CONFIRM: (id) =>
			`${baseUrl}/api/v1/user_panel/user/${id}/change_mobile`,
		WIZARD: () => `${baseUrl}/api/v1/user_panel/user/wizard_step`,
		ASNAAF_LOGIN: () => `${baseUrl}/api/v1/user_panel/guild`,
		FRESH_REGISTER: () =>
			`${baseUrl}/api/v1/user_panel/auth/register_fresh_merchant`,
		CREATE_BUSINESS: () => `${baseUrl}/api/v2/user_panel/business`,
	},
	BUSINESS: {
		CREATE_BUSINESS: () => `${baseUrl}/api/v2/user_panel/business`,
		CATEGORIES: (params = {}) =>
			`${baseUrl}/api/categories?${
				params?.display_child ? 'display_child=true' : ''
			}`,
		GET_BUSINESS: (params = {}) =>
			`${baseUrl}/api/v1/user_panel/business${
				params?.businessId ? `/${params?.businessId}` : ''
			}`,
		GET_BUSINESS_list: (params = {}) =>
			`${baseUrl}/api/v1/user_panel/business${
				params?.businessId ? `/${params?.businessId}` : ''
			}?sub_users_business=true`,
		RATEANDREVIEW: ({ businessId }) =>
			`${baseUrl}/api/v1/user_panel/business/${businessId}/review`,
		UPDATE_COMMISION: (businessId) =>
			`${baseUrl}/api/v1/user_panel/business/${businessId}/update_commission`,
		MARKETING_REPORT: (date, businessId) =>
			`${baseUrl}/api/v1/user_panel/marketing_report/summary?date=(${date})&business_id=${businessId}`,
		CONTRACT_LINK: (businessId) =>
			`${baseUrl}/api/v1/user_panel/business/${businessId}/send_digital_contract_link`,

		CONTRACT_SIGN: () => `${baseUrl}/api/digital_contracts/sign`,
		CONTRACT_BUSINESS_INFO: (token) =>
			`${baseUrl}/api/digital_contracts?token=${token}`,

		COMMENTIFY: () => `${baseUrl}/api/v2/user_panel/commentify`,
		PACKAGES: (businessId, filters) =>
			`${baseUrl}/api/v2/user_panel/business/${businessId}/package?${filters}`,
		SUPER_USER: (userId) =>
			`${baseUrl}/api/v1/user_panel/user/${userId}/sub_user`,
		CASHIER_MACHINES: () => `${baseUrl}/api/v1/user_panel/cash_registers`,
	},
	NOTIFICATION: {
		FETCH: (userId) => `${baseUrl}/api/v1/user_panel/user/${userId}/message`,
		UPDATE: (params) =>
			`${baseUrl}/api/v1/user_panel/user/${params.userId}/message/${params.messageId}`,
	},
	PACKAGE: {
		GET_V2_PACKAGES: (params) =>
			`${baseUrl}/api/v2/user_panel/category/${params.id}/package?business_id=${
				params.businessId
			}${params.workflow ? `&workflow_state=${params.workflow}` : ''}`,
		GET_V1_PACKAGES: (params) =>
			`${baseUrl}/api/v1/user_panel/package${
				params?.packageId ? `/${params.packageId}` : ''
			}`,
		UPDATE_STATUS: (params) =>
			`${baseUrl}/api/v1/user_panel/package/${params.packageId}/update_status`,
		CREATE: (params) =>
			`${baseUrl}/api/v1/user_panel/business/${params.business_id}/package`,
		INDEX: (filters) => `${baseUrl}/api/v1/user_panel/package?${filters}`,
		PRODUCTS_INDEX: (businessId, params) =>
			`${baseUrl}/api/v1/user_panel/business/${businessId}/products?${params}`,
		BEST_SELLING: (params) =>
			`${baseUrl}/api/v1/user_panel/marketing_report/best_selling?${params}`,
	},
	POSE: {
		INDEX: (filters) =>
			`${baseUrl}/api/v1/user_panel/offline_cashback_pos?${filters}`,
		DEACTIVE: (id) =>
			`${baseUrl}/api//v1/user_panel/offline_cashback_pos/${id}/update_state`,
		ADDPOSE: (businessId) =>
			`${baseUrl}/api/v1/user_panel/business/${businessId}/offline_cashback_pos`,
		GETITEM: (id) =>
			`${baseUrl}/api/v1/user_panel/offline_cashback_pos?filters[terminal_id]=${id}`,
		EDITPOSE: (id) => `${baseUrl}/api/v1/user_panel/offline_cashback_pos/${id}`,
	},
	CATEGORY: {
		ACTIVES: (businessId) =>
			`${baseUrl}/api/v2/user_panel/category/actives?business_id=${businessId}`,
		SUB_CATEGORIES: (categoryId) =>
			`${baseUrl}/api/v2/user_panel/category/${categoryId}`,
		DYNAMIC_ATTRIBUTES: (categoryId) =>
			`${baseUrl}/api/v1/user_panel/category/${categoryId}/dynamic_attributes`,
		TAGS: () => `${baseUrl}/api/v1/user_panel/category/level4`,
		RECOMMONED_COMMISION: (categoryId) =>
			`${baseUrl}/api/v1/user_panel/category/${categoryId}`,
	},
	FILE: {
		UPLOAD: () => `${baseUrl}/api/v1/user_panel/uploads`,
		DELETE: (params) =>
			`${baseUrl}/api/v1/user_panel/uploads/${params.model_name}/${
				params.image_key
			}${params.model_id ? `/${params.model_id}` : ''}/${params.index}`,
		READ_FROM_PATH: (path) => `${baseUrl}${path}`,
	},
	COUPON: {
		INDEX: (filters) => `${baseUrl}/api/v1/user_panel/coupon/index?${filters}`,
		INVALIDATE: (filters) =>
			`${baseUrl}/api/v1/user_panel/coupon/${filters}/invalidate`,
		INDEX_PER_MOBILE: (filters) =>
			`${baseUrl}/api/v1/user_panel/coupon/per_mobile?customer_mobile=${filters}`,
	},
	LOCATION: {
		LIST: (params) =>
			`${baseUrl}/api/locations${params.id ? `/${params.id}` : ''}${
				params.type ? `?type=${params.type}` : ''
			}`,

		NESHAN_POSITION: (params) =>
			`https://api.neshan.org/v4/geocoding?address=${params.address}`,
		POINT_TO_ADDRESS: () => `${baseUrl}/api/v1/user_panel/neshan/get_location`,
	},

	TICKET: {
		LIST: () => `${baseUrl}/api/v1/user_panel/ticket?ticket_type=business`,

		INDEX: (id) => `${baseUrl}/api/v1/user_panel/support_ticket/${id}`,

		CREATE: () => `${baseUrl}/api/v1/user_panel/support_ticket`,

		COMMENT: (id) =>
			`${baseUrl}/api/v1/user_panel/support_ticket/${id}/comment`,

		LOGS: (id) => `${baseUrl}/api/v1/user_panel/support_ticket/${id}/logs`,
		SUPPORT_TICKET: (filter) =>
			`${baseUrl}/api/v1/user_panel/support_problem?${filter}`,
	},
	FINANCIAL: {
		BALANCE: (params) =>
			`${baseUrl}/api/v1/user_panel/business/${params?.businessId}/amount_detail`,
		BALANCE_DETAILS: (params) =>
			`${baseUrl}/api/v1/user_panel/business/${params?.businessId}/payable_amount_in_detail`,

		VERIFY_PAYMENT: (params) =>
			`${baseUrl}/api/v1/user_panel/business/${params?.businessId}/verify_payment`,

		PAYMENT_REQUEST: (params) =>
			`${baseUrl}/api/v1/user_panel/business/${params?.businessId}/payment_request`,

		PAYMENT_HISTORY_LIST: (params) => {
			return `${baseUrl}/api/v1/user_panel/payment_request?page=${
				params?.page || 1
			}`;
		},

		PAYMENT_REQUEST_DETAILS: (params) =>
			`${baseUrl}/api/v1/user_panel/payment_request/${params?.paymentId}/details`,

		TRANSACTIONS: (params) =>
			`${baseUrl}/api/v1/user_panel/payment_request/${params?.id}/financial_transaction`,
	},
	COMMENTIFY: {
		REPLY: (id) => `${baseUrl}/api/v2/user_panel/commentify/${id}/reply`,
	},
	QUESTION: {
		LIST: () => `${baseUrl}/api/v1/user_panel/question`,
		REPLY: (questionId) =>
			`${baseUrl}/api/v1/user_panel/question/${questionId}/answer`,
	},
	REPORTS: {
		COUPON_TRANSACTIONS: () =>
			`${baseUrl}/api/v1/user_panel/marketing_report/coupons_index`,
		COUPONS_TRANSACTIONS_OVERVIEW: () =>
			`${baseUrl}/api/v1/user_panel/marketing_report/coupons`,
		PAYMENT_REQUEST_TRANSACTIONS: () =>
			`${baseUrl}/api/v1/user_panel/marketing_report/financial_report`,
		PAYMENT_REQUEST_TRANSACTIONS_OVERVIEW: () =>
			`${baseUrl}/api/v1/user_panel/marketing_report/request_for_settlement_summary`,
		TRANSACTION_PACKAGE: (businessId) =>
			`${baseUrl}/api/v2/user_panel/business/${businessId}/package`,
		CHART_PACKAGE: () =>
			`${baseUrl}/api/v1/user_panel/marketing_report/used_coupons`,
		CHART_PACKAGE_OFFCB: () =>
			`${baseUrl}/api/v1/user_panel/marketing_report/offcb_total`,
		TRANSACTION_PACKAGE_OFFCB: () =>
			`${baseUrl}/api/v1/user_panel/marketing_report/offcb_details`,
	},
	WALLET_PAYMENT: {
		NEW_TRANSACTION: () => `${baseUrl}/api/v1/user_panel/takhfifan_payment`,
		BARCODE_CHECK: (id) =>
			`${baseUrl}/api/v1/user_panel/takhfifan_payment/${id}/barcode`,
		TRANSACTION_REPORTS: () =>
			`${baseUrl}/api/v1/user_panel/takhfifan_payment?filters[status]=done&filters[sort_order]=desc&filters[sort]=id`,
	},
};
